
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"100","width":"100","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 14c1.312 0 2.427.842 2.835 2.015l.048-.008L13 16h6a1 1 0 01.117 1.993L19 18h-6c-.057 0-.112-.005-.166-.014a3 3 0 01-5.669-.001l-.048.008L7 18H1a1 1 0 01-.117-1.993L1 16h6c.057 0 .112.005.166.014A3 3 0 0110 14zm0 2a1 1 0 100 2 1 1 0 000-2zM3 7c1.312 0 2.427.842 2.835 2.015l.048-.008L6 9h13a1 1 0 01.117 1.993L19 11H6c-.057 0-.112-.005-.166-.014A3 3 0 113 7zm0 2a1 1 0 100 2 1 1 0 000-2zm11-9c1.312 0 2.427.842 2.835 2.015l.048-.008L17 2h2a1 1 0 01.117 1.993L19 4h-2c-.057 0-.112-.005-.166-.014a3 3 0 01-5.669-.001l-.048.008L11 4H1a1 1 0 01-.117-1.993L1 2h10c.057 0 .112.005.166.014A3 3 0 0114 0zm0 2a1 1 0 100 2 1 1 0 000-2z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    